import React, { ReactElement, ReactNode } from 'react';
import { mergeClasses, Text } from '@fluentui/react-components';

import { useEmptyStateSizeContext } from '../contexts/size';
import { useEmptyStateContentStyles } from './empty-state-content-styles';

interface EmptyStateContentProps {
  className?: string;
  children: ReactNode;
  title?: string;
  subtext?: string | ReactElement;
}

const fallbackTitle = _TL_('No matching results');
export const EmptyStateContent = ({
  children,
  className,
  title,
  subtext,
}: EmptyStateContentProps) => {
  const classes = useEmptyStateContentStyles();
  const { size } = useEmptyStateSizeContext();

  return (
    <div className={mergeClasses(className, classes.container)}>
      <div className={mergeClasses('content', classes.content)}>
        {children}
        <Text as="h3" className={mergeClasses('content-title', classes[`title-${size}`])}>
          {title || fallbackTitle}
        </Text>
        <Text as="p" className={mergeClasses('content-subtext', classes[`subtext-${size}`])}>{subtext}</Text>
      </div>
    </div>
  );
};
